const pendingCommits = new Set<() => void>();

const commitAllPending = () => {
    pendingCommits.forEach((commit) => commit());
};

let isListeningForPageHide = false;

/**
 * Runs `commit` once `delayMs` has passed, giving the user that long to cancel it. If the page is
 * closed or navigated away from first, it runs right away so the user's action is not lost.
 *
 * Returns a function that cancels the commit if it hasn't run yet, and reports whether it did.
 */
export function deferCommit(commit: () => void, delayMs: number): () => boolean {
    if (!isListeningForPageHide) {
        window.addEventListener('pagehide', commitAllPending);
        isListeningForPageHide = true;
    }

    const runOnce = () => {
        clearTimeout(timeoutId);
        pendingCommits.delete(runOnce);
        commit();
    };
    const timeoutId = setTimeout(runOnce, delayMs);
    pendingCommits.add(runOnce);

    return () => {
        if (!pendingCommits.has(runOnce)) {
            return false;
        }
        clearTimeout(timeoutId);
        pendingCommits.delete(runOnce);
        return true;
    };
}
